import { HashRouter as Router} from 'react-router-dom';
import Proutes from './common/router';

function App() {
  return (
      <Router>
        <Proutes />
      </Router>
  );
}

export default App;
